import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import type { ReactNode } from "react";
import MediaDisplay from "@/components/drops/view/item/content/media/MediaDisplay";
import type { ResolvedPreviewHref } from "./MarketplaceItemPreviewCard.types";
import { MARKETPLACE_MEDIA_FRAME_CLASS } from "./previewLayout";
interface MarketplaceItemPreviewMediaLinkProps {
  readonly mediaUrl: string;
  readonly mediaMimeType: string;
  readonly resolvedPreviewHref: ResolvedPreviewHref;
}
const isImageMimeType = (mimeType: string): boolean => mimeType.toLowerCase().includes("image");
const isVideoMimeType = (mimeType: string): boolean => mimeType.toLowerCase().includes("video");
const isGammaioHref = (href: string): boolean => {
  try {
    const url = new URL(href);
    const hostname = url.hostname.toLowerCase();
    return hostname === "gamma.io" || hostname === "www.gamma.io";
  } catch {
    return false;
  }
};
export default function MarketplaceItemPreviewMediaLink(t0) {
  const $ = _c(13);
  const {
    mediaUrl,
    mediaMimeType,
    resolvedPreviewHref
  } = t0;
  const href = resolvedPreviewHref.href;
  const isImage = isImageMimeType(mediaMimeType);
  const isVideo = isVideoMimeType(mediaMimeType);
  const useDirectImageRendering = isImage && isGammaioHref(href);
  const mediaFrameClassName = useDirectImageRendering ? "tw-box-border tw-w-full tw-bg-inherit tw-p-4 md:tw-p-6" : MARKETPLACE_MEDIA_FRAME_CLASS;
  let mediaContent;
  if (useDirectImageRendering) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        imageRendering: "pixelated"
      };
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== mediaMimeType || $[2] !== mediaUrl) {
      t2 = <Image src={mediaUrl} alt="Marketplace item media" width={320} height={320} unoptimized={true} className="tw-block tw-h-auto tw-max-h-72 tw-min-h-[12.5rem] tw-w-auto tw-min-w-[12.5rem] tw-max-w-full tw-object-contain" style={t1} data-testid="media-display" data-mime={mediaMimeType} data-url={mediaUrl} data-disable="true" />;
      $[1] = mediaMimeType;
      $[2] = mediaUrl;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    mediaContent = t2;
  } else {
    if (isVideo) {
      let t1;
      if ($[4] !== mediaMimeType || $[5] !== mediaUrl) {
        t1 = <video src={mediaUrl} className="tw-h-full tw-w-full tw-rounded-xl tw-object-contain" muted={true} loop={true} playsInline={true} preload="auto" autoPlay={true} data-testid="media-display" data-mime={mediaMimeType} data-url={mediaUrl} data-disable="true" />;
        $[4] = mediaMimeType;
        $[5] = mediaUrl;
        $[6] = t1;
      } else {
        t1 = $[6];
      }
      mediaContent = t1;
    } else {
      let t1;
      if ($[7] !== mediaMimeType || $[8] !== mediaUrl) {
        t1 = <MediaDisplay media_mime_type={mediaMimeType} media_url={mediaUrl} disableMediaInteraction={true} />;
        $[7] = mediaMimeType;
        $[8] = mediaUrl;
        $[9] = t1;
      } else {
        t1 = $[9];
      }
      mediaContent = t1;
    }
  }
  const t1 = `${mediaFrameClassName} tw-relative tw-flex tw-items-center tw-justify-center tw-overflow-hidden`;
  let t2;
  if ($[10] !== mediaContent || $[11] !== t1) {
    t2 = <div className="tw-flex tw-w-full tw-flex-col tw-overflow-hidden" data-testid="marketplace-item-media-link"><div className={t1} data-testid="manifold-item-media">{mediaContent}</div></div>;
    $[10] = mediaContent;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}